<template>
  <transition name="video-modal-fade">
    <div v-if="modelValue" class="video-modal-mask" @click.self="close">
      <div class="video-modal-panel">
        <div class="video-modal-header">
          <button class="close-btn" @click="close">
            <img
              src="@/assets/close-yellow.png"
              class="close-icon"
              alt="close"
            />
          </button>
        </div>
        <div class="video-modal-body">
          <video
            ref="videoRef"
            class="video-player"
            :src="videoUrl"
            controls
            autoplay
            preload="metadata"
            @loadeddata="onVideoLoaded"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { ref, defineProps, defineEmits, watch } from "vue";

interface Props {
  modelValue: boolean;
  videoUrl: string;
}

const props = defineProps<Props>();
const emits = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
}>();

const videoRef = ref<HTMLVideoElement>();

const close = () => {
  // 停止视频播放
  if (videoRef.value) {
    videoRef.value.pause();
  }
  emits("update:modelValue", false);
};

const onVideoLoaded = () => {
  // 视频加载完成后的处理
  console.log("视频加载完成");
};

// 监听弹窗关闭，确保视频停止播放
watch(
  () => props.modelValue,
  (newValue) => {
    if (!newValue && videoRef.value) {
      videoRef.value.pause();
    }
  }
);
</script>

<style scoped lang="scss">
.video-modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.video-modal-panel {
  background: #000;
  border-radius: 12px;
  overflow: hidden;
  max-width: 90vw;
  max-height: 90vh;
  width: 800px;
  height: 600px;
  position: relative;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.video-modal-header {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  padding: 16px;

  .close-btn {
    background: rgba(255, 255, 255);
    border: none;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      transform: scale(1.1);
    }

    .close-icon {
      width: 30px;
      height: 30px;
      filter: brightness(1);
    }
  }
}

.video-modal-body {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .video-player {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background: #000;
  }
}

.video-modal-fade-enter-active,
.video-modal-fade-leave-active {
  transition: all 0.3s ease;
}

.video-modal-fade-enter-from,
.video-modal-fade-leave-to {
  opacity: 0;
  transform: scale(0.9);
}

.video-modal-fade-enter-to,
.video-modal-fade-leave-from {
  opacity: 1;
  transform: scale(1);
}
</style>
